<template>
    <div class="mt-5">
        <service-filter-modal :owner-options="owners" :tag-options="tags"></service-filter-modal>
        <confirmation-modal></confirmation-modal>
        <link-payer-authorization-modal></link-payer-authorization-modal>

        <div class="border-bottom d-flex justify-content-between align-items-end">
            <div class="h4">
                <a href="javascript:void(0)" class="mr-2" role="button" @click="collapsed = !collapsed">
                    <i :class="['fas text-muted', collapsed ? 'fa-caret-right' : 'fa-caret-down']"></i>
                </a>
                Health Insurance Claim Forms 
                <span class="font-small-italic text-muted">(CMS 1500/1450)</span>                               
            </div>                
            <div v-if="!collapsed" class="btn-toolbar" role="toolbar">
                <div class="input-group input-group-sm mr-2">
                    <div class="input-group-prepend">
                        <div class="input-group-text"><i class="fas fa-search fa-sm text-muted"></i></div>
                    </div>
                    <input type="text" class="form-control" placeholder="Search Descriptions" v-model="searchString">
                </div>
                <div class="btn-group"> 
                    <button type="button" class="btn btn-primary btn-sm mb-1" data-toggle="tooltip" title="Filter" @click="showFilters"><i class="fas fa-filter fa-lg"></i></button>
                    <button type="button" class="btn btn-primary btn-sm mb-1" data-toggle="tooltip" title="Upload File" @click="uploadDocument()"><i class="fas fa-file-upload fa-lg"></i></button>
                </div>
            </div>
        </div>
        <div id="servicesTable" :class="['collapse', { 'show': !collapsed }]">
            <div v-if="isLoading" class="pt-3">            
                <h3 class="text-muted text-center"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</h3>
            </div>
            <div v-else-if="filteredDocuments.length === 0" class="border-top"><h3 class="text-muted text-center mt-3">No Documents.</h3></div>
            <div v-else>
                <div v-if="actionsVisible">
                    <div v-if="transmissionsDisabled" class="alert alert-danger fade show px-3 py-2 mt-2  font-weight-bold">
                        Transmitting documents has been disabled.
                    </div>                    
                    <div v-else class="alert alert-primary fade show px-3 py-2 mt-2 d-flex justify-content-between">
                        <div>                    
                            <submit-button @clickfax="showFaxSubmission()" @clickemail="showEmailSubmission()" :emailEnabled="emailEnabled"></submit-button> 
                            <button type="button" class="btn btn-sm btn-secondary ml-3 font-weight-bold" @click="clearSelections()">CANCEL</button>                    
                        </div>                    
                        <div class="pt-1">
                            {{ selectedDocuments.length }} document{{ selectedDocuments.length > 1 ? 's' : '' }} selected.
                        </div>
                    </div>
                </div>
                <div v-else class="m-2">
                    <div>
                        <span class="fa-stack fa-xs instructions-icon">
                            <i class="far fa-circle fa-stack-2x"></i>
                            <i class="fas fa-info fa-stack-1x fa-sm"></i>
                        </span>
                        <span class="instructions">
                            Use the checkboxes to initiate submitting Health Insurance Claim document(s) to payer. Checkbox will be disabled if there is no
                            payer authorization or explanation for missing payer authorization associated with the claim.
                        </span>
                    </div>
                    <!-- <div>
                        <span class="fa-stack fa-xs instructions-icon">
                            <i class="far fa-circle fa-stack-2x"></i>
                            <i class="fas fa-link fa-stack-1x fa-sm"></i>
                        </span>
                        <span class="instructions">
                            Indicates an Authorization Response has not been associated with the claim. Click the button to associated a repsonse.
                        </span>
                    </div>                     -->
                </div>                
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th class="fit"></th>
                            <th class="fit">Document Type</th>
                            <th>PAN</th>
                            <th>DOS</th>
                            <th>Description</th>
                            <th class="fit">Owner</th>
                            <th class="fit">Uploaded/Received</th>
                            <th class="fit">Submitted</th>
                            <th>Estimated Reimbursement</th>
                            <th>Balance</th>
                            <th>Tags</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(doc) in filteredDocuments">
                            <tr class="table-stripe" :key="'service-document-' + doc.id">
                                <td class="fit pr-0">                                                                                                     
                                    <div class="d-flex justify-content-start align-items-center">
                                        <div v-if="doc.included_in_1008"><i class="fas fa-sm fa-fw fa-balance-scale text-muted"></i></div>                                                                     
                                        <div v-else  class="custom-control custom-checkbox">
                                            <input :id="'service-document-checkbox-' + doc.id" type="checkbox" class="custom-control-input" true-value="true" false-value="false" v-model="doc.selected" @change="onChange($event, doc)" :disabled="!doc.has_associated_authorization">
                                             <label v-if="doc.has_associated_authorization" class="custom-control-label align-top" :for="'service-document-checkbox-' + doc.id">
                                                <span class="sr-only"></span>
                                            </label>
                                            <label v-else class="custom-control-label align-top" :for="'service-document-checkbox-' + doc.id" :title="attentionMessage" @click="showPayerAuthorization(doc)">
                                                <span class="attention">
                                                    <i class="fas fa-exclamation-triangle fa-lg text-warning"></i>
                                                </span>                                            
                                            </label>                  
                                        </div>                                    
                                        <div>
                                            <a v-if="doc.associated_documents.length" data-toggle="collapse" role="button" @click="doc.collapsed = !doc.collapsed">
                                                <i :class="['fas fa-lg fa-fw text-muted', doc.collapsed ? 'fa-caret-right' : 'fa-caret-down']"></i>
                                            </a>
                                            <i v-else class="fas fa-lg fa-fw"></i>
                                        </div>                                        
                                        <div>
                                            <document-status-icon :document-id="doc.id" :document-status="doc.document_status"></document-status-icon>                                            
                                        </div>
                                    </div>                            
                                </td>
                                <td class="fit px-0">
                                    <document-type-icon :document="doc" :href="'/claims/' + claimId + '/documents/' + doc.id"></document-type-icon> 
                                    <!-- <i :class="['text-muted mr-1', getIconClass(doc)]"></i>
                                    <a :href="'/claims/' + claimId + '/documents/' + doc.id" target="_blank" :class="getReadClass(doc)">{{ doc.document_type.name }}</a> -->
                                </td>
                                <td class="fit"><a class="btn btn-link p-0" title="View Service Details" :href="'/claims/' + claimId + '/documents/' + doc.id + '/services'" :disabled="doc.disable_details">{{ doc.pan }}</a></td>
                                <td class="fit">{{ doc.dos }}</td>
                                <td>
                                    <input v-if="doc.edit" class="form-control form-control-sm" v-model="doc.description" @blur="changeDescription(doc)" @keyup.enter="changeDescription(doc)" v-focus>
                                    <span v-else @click="doc.edit = true;" :title="doc.description">                                
                                        {{ doc.description | truncate(80) }}
                                        <a href="javascript:void(0)" class="edit-button"><i class="fas fa-pencil-alt fa-xs"></i></a>
                                    </span>
                                </td>
                                <td class="fit">{{ doc.owner }}</td>
                                <td class="fit">{{ doc.created_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                                <td class="fit">{{ doc.submitted_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                                <td class="fit text-right">{{ doc.estimated_reimbursement | currency }}<sup v-if="doc.has_contract">*</sup></td>
                                <td :class="['fit text-right', { 'text-danger' : doc.balance > 0}]">{{ doc.balance | currency }}</td>
                                <td class="fit pr-1">
                                    <document-tags-button :document="doc"></document-tags-button>
                                </td>
                                <td class="fit p-0">
                                    <div class="d-flex flex-nowrap justify-content-end align-items-center"> 

                                        <!-- show submission history -->
                                        <div class="mx-1">
                                            <button v-if="doc.can_show_history" class="btn btn-link px-1" title="Submission History" @click="showSubmissionHistory(doc.id)">
                                                <span class="fa-stack fa-xs fa-fw"> 
                                                    <i class="fas fa-history fa-lg fa-stack-2x"></i>
                                                    <i :class="['fas fa-lg fa-stack-1x history-badge', 
                                                        { 'fa-check-circle text-success': doc.last_submission_status_code == TransmissionStatus.SUCCESS, 
                                                          'fa-exclamation-circle text-danger': doc.last_submission_status_code == TransmissionStatus.FAILURE,
                                                          'fa-spinner fa-spin text-secondary': doc.last_submission_status_code == TransmissionStatus.IN_PROGRESS }]"></i>
                                                </span>
                                            </button>
                                            <i v-else class="fas fa-lg fa-fw"></i>
                                        </div>

                                        <!-- submitted by mail -->
                                        <div class="mx-0">
                                            <mailed-button :mailed="!!doc.mailed_date" :received="!!doc.received_date" @click="uploadMailing(doc)"></mailed-button>
                                        </div>                                                                                                            
                              
                                        <!-- upload associated document -->
                                        <div class="mx-1">
                                            <button class="btn btn-link p-0" title="Upload Associated Document" @click="uploadDocument(doc)">
                                                <i class="fas fa-file-upload fa-lg fa-fw"></i>
                                            </button>
                                        </div>

                                        <!-- associate payer authorization -->
                                        <div class="mx-1">
                                            <button class="btn btn-sm btn-link p-0" title="Link Payer Authorization to Claim" @click="showPayerAuthorization(doc)">
                                                <i :class="['fas fa-thumbs-up fa-lg', { 'text-success': doc.has_associated_authorization }]"></i>
                                            </button>
                                        </div>

                                        <!-- document notes -->
                                        <div class="mx-1">
                                            <button class="btn btn-link p-0" title="Add/View Document Notes" @click="onDocumentNotes(doc)">
                                                <i class="fas fa-comment fa-lg fa-fw"></i>
                                            </button>
                                        </div>                                                                                                                        

                                        <!-- delete document -->
                                        <div class="mx-0">
                                            <button class="btn btn-link p-0" :class="{'invisible': !doc.can_delete}" title="Delete Document" @click="confirmDelete(doc.id)">
                                                <i class="fas fa-trash-alt fa-lg fa-fw"></i>
                                            </button>                                  
                                        </div>                               

                                        <!-- send to financing - admin only --->
                                        <div v-if="isAdmin" class="mx-0">
                                            <button class="btn btn-link p-0" title="Send to Financing" @click="confirmFinancing(doc.id)">
                                                <i class="far fa-credit-card fa-lg fa-fw"></i>
                                            </button>
                                        </div>                                                                                                     
                                    </div>
                                </td>
                            </tr>                

                            <template id="associatedDocuments" class="collapse">
                                <tr v-show="!doc.collapsed" v-for="associatedDoc in doc.associated_documents" :key="'services-associated-' + doc.id + '-' + associatedDoc.id"  class="font-small">
                                    <td class="fit">
                                        <i class="fas fa-fw fa-lg"></i>
                                    </td>
                                    <td class="fit pl-4" colspan="3">
                                        <span :class="associatedDoc.read_by ? 'cursor-pointer' : ''" 
                                            data-toggle="popover" 
                                            data-placement="left" 
                                            :data-content="getReadContent(associatedDoc)">
                                            <i :class="['text-muted mr-1', getIconClass(associatedDoc)]"></i>
                                        </span>
                                        <a :href="'/claims/' + claimId + '/documents/' + associatedDoc.id" target="_blank" :class="getReadClass(associatedDoc)">{{ associatedDoc.document_type.name }}</a>                             
                                    </td>                                   
                                    <td>
                                        <input v-if="associatedDoc.edit" class="form-control form-control-sm" v-model="associatedDoc.description" @blur="changeDescription(associatedDoc)" @keyup.enter="changeDescription(associatedDoc)" v-focus>
                                        <span v-else @click="associatedDoc.edit = true;" :title="associatedDoc.description">                                    
                                            {{ associatedDoc.description | truncate(80) }}
                                            <a href="javascript:void(0)" class="edit-button"><i class="fas fa-pencil-alt fa-xs"></i></a>
                                        </span>
                                    </td>
                                    <td class="fit">{{ associatedDoc.owner }}</td>
                                    <td class="fit">{{ associatedDoc.created_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                                    <td class="fit">{{ associatedDoc.submitted_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="fit p-0">
                                        <div class="d-flex flex-nowrap justify-content-end align-items-center">

                                            <div class="mx-1">
                                                <!-- disassociate document -->
                                                <button  v-if="associatedDoc.can_disassociate" class="btn btn-link p-0" title="Unlink from Document" @click="confirmDisassociate(doc.id, associatedDoc.id)">
                                                    <i class="fas fa-unlink fa-lg fa-fw"></i>
                                                </button>

                                                <!-- delete document -->
                                                <button v-else-if="associatedDoc.can_delete" class="btn btn-link p-0" title="Delete Document" @click="confirmDelete(associatedDoc.id)">
                                                    <i class="fas fa-trash-alt fa-lg fa-fw"></i>
                                                </button>

                                                <!-- non-clickable button to keep spacing -->
                                                <button v-else class="btn btn-link px-1">
                                                    <i class="fas fa-lg fa-fw"></i>
                                                </button>                                                                                                                                              
                                            </div>

                                        </div>
                                    </td>                        
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
                <div v-if="showFootnote" class="font-italic text-muted">
                    * <small>{{ ContractDisclaimer }}</small>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
import { DocumentType, DocumentStatus, TransmissionStatus, ContractDisclaimer } from '../../constants.js';
import DocumentStatusIcon from './DocumentStatusIconComponent.vue';
import DocumentTypeIcon from './DocumentTypeIconComponent.vue';
import ServiceFilterModal from './ServiceDocumentsFilterComponent.vue';
import SubmitButton from '../buttons/SubmitButtonComponent.vue';
import MailedButton from '../buttons/MailedButtonComponent.vue';
import DocumentTagsButton from '../buttons/DocumentTagsButtonComponent.vue';
import LinkPayerAuthorizationModal from '../LinkPayerAuthorizationComponent.vue';

export default {
    components: {
        DocumentStatusIcon,
        DocumentTypeIcon,
        ServiceFilterModal,
        SubmitButton,
        MailedButton,
        DocumentTagsButton,
        LinkPayerAuthorizationModal
    },
    props: {
        claimId: Number,
        isAdmin: Boolean,
        emailEnabled: Boolean,
        documentId: String
    },
    data() {
        return {

            // import constants into the template
            DocumentType: DocumentType,
            DocumentStatus: DocumentStatus,
            TransmissionStatus: TransmissionStatus,
            ContractDisclaimer: ContractDisclaimer,

            documents: [],
            searchString: '',
            filters: {
                status: '',
                owner: '',
                tagInclusion: 'include',
                tag: '',
                dos: {
                    begin: null,
                    end: null
                },                
                submitted: {
                    begin: null,
                    end: null
                },
                balance: {
                    operator: 'any',
                    min: null,
                    max: null
                }                
            },
            collapsed: false,
            isLoading: false,
            options: [],
            attentionMessage: 'Missing payer authorization. Click to attach.',
            transmissionsDisabled: false
        }
    },
    computed: {
        owners: function () {
            return [...new Set(this.documents.map(e => e.owner))];
        },
        tags: function () {
            return [...new Set(this.documents.map(d => d.tags.map(t => t.tag)).flat(1))]
        },   
        filteredDocuments: function () {
            const self = this;
            let retval = this.documents;

            // filter on description
            retval = retval.filter(doc => (doc.description.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1));            

            if (self.filters) {     
                                
                // filter on tag
                if (self.filters.tagInclusion === 'include') {
                    
                    // if a tag has been set then filter the documents on that tag
                    if (self.filters.tag.trim() !== '') { 
                        retval = retval.filter(e => (e.tags.some(t => t.tag.toLowerCase() === self.filters.tag.toLowerCase())));
                    }
                }
                else if (self.filters.tagInclusion === 'exclude') {

                    // if a tag has been set return all documents that don't have that tag
                    if (self.filters.tag.trim() !== '') {
                        retval = retval.filter(e => (!e.tags.some(t => t.tag.toLowerCase() === self.filters.tag.toLowerCase())));
                    }
                    else {
                        retval = retval.filter(e => !e.tags.length);
                    }
                }

                // filter on status
                if (self.filters.status !== '') {
                    retval = retval.filter(e => e.document_status.id == self.filters.status);
                }

                // filter on owner
                if (self.filters.owner) {
                    retval = retval.filter(e => (e.owner && (e.owner.toLowerCase() === self.filters.owner.toLowerCase())));
                }
                
                // filter on date of service
                if (self.filters.dos.begin && self.filters.dos.end) {
                    retval = retval.filter(e => {
                        return (e.dos >= self.filters.dos.begin && e.dos <= self.filters.dos.end);
                    });
                }               

                // filter on submitted date; we have to convert the date to local time and drop the time
                // portion in order to do the comparison properly
                if (self.filters.submitted.begin && self.filters.submitted.end) {
                    retval = retval.filter(e => {
                        let submittedAt = self.getLocalDate(e.submitted_at);
                        return (submittedAt >= self.filters.submitted.begin && submittedAt <= self.filters.submitted.end) ||
                            e.associated_documents.filter(x => {
                                let submittedAt = self.getLocalDate(x.submitted_at);
                                return submittedAt >= self.filters.submitted.begin && submittedAt <= self.filters.submitted.end
                            }).length;
                    });
                }

                // filter on balance
                if (self.filters.balance.operator && (self.filters.balance.operator !== 'any') && this.filters.balance.min) {

                    switch(self.filters.balance.operator)
                    {
                        case '=':
                            retval = retval.filter(e => parseFloat(e.balance) === parseFloat(this.filters.balance.min));
                            break;
                        case '!=':
                            retval = retval.filter(e => parseFloat(e.balance) != parseFloat(this.filters.balance.min));
                            break;                                
                        case '<':
                            retval = retval.filter(e => parseFloat(e.balance) < parseFloat(this.filters.balance.min));
                            break;                                
                        case '>':
                            retval = retval.filter(e => parseFloat(e.balance) > parseFloat(this.filters.balance.min));
                            break;                                
                        case 'between':
                            if (this.filters.balance.max) {
                                retval = retval.filter(e => (e.balance && (parseFloat(e.balance) >= parseFloat(self.filters.balance.min)) && 
                                    (parseFloat(e.balance) <= parseFloat(self.filters.balance.max))));
                            }
                            break; 
                    }
                }                
            }
    
            return retval;
        },
        selectedDocuments: function () {
            return this.documents.filter(e => e.selected).map(e => {
                return {
                    id: e.id,
                    document_type: {
                        id: e.document_type_id,
                        name: e.document_type.name
                    },
                    description: e.description
                };
            });
        },         
        actionsVisible: function () {
            return this.selectedDocuments.length;
        },
        showFootnote: function () {
            return this.documents.some((document) => document.has_contract);
        }             
    },    
    methods: {
        refresh: function (reset=false) {

            const self = this;

            // only display loading indicator when page is initially loading
            self.isLoading = reset;
            axios.get('/ajax/claims/' + self.claimId + '/services')
                .then(response => {

                    this.transmissionsDisabled = response.data.transmissions_disabled;

                    const inboundTypes = [
                        DocumentType.INBOUND_FAX,
                        DocumentType.REMITTANCE
                    ];

                    if (reset) {
                        self.collapsed = response.data.collapsed;
                        this.options = response.data.options;
                    }

                    // set the collapsed flag for each document 
                    self.documents = response.data.documents.map(e => {

                        // add selected flag to each document
                        self.$set(e, 'selected', false);                       

                        // add edit flag to each document and associated documents
                        self.$set(e, 'edit', false);
                        e.associated_documents = e.associated_documents.map(x => {
                            self.$set(x, 'edit', false);
                            return x;
                        });
                        
                        // collapse if all associated documents have been read
                        let unreadDocs = e.associated_documents.filter(a => { 
                            return inboundTypes.includes(a.document_type_id) && !a.read_by; 
                        });
                        
                        let collapsed = unreadDocs.length === 0;

                        // if we are not reseting
                        if (!reset) {

                            // if we can find the document then retain the previous collapse state
                            let doc = this.documents.find(d => d.id === e.id);
                            if (doc) {
                                collapsed = doc.collapsed;
                            }                        
                        }

                        self.$set(e, 'collapsed', collapsed);

                        return e; 
                    });
                    
                    // if the tag we are currently filtering on has been deleted clear the tag filter
                    if (!self.tags.some(t => t.toLowerCase() === self.filters.tag.toLowerCase())) {
                        self.filters.tag = '';
                    }

                    // enable popover tooltips and display the modal after the data has been set and the DOM has updated
                    self.$nextTick(() => {
                        $('[data-toggle="tooltip"]').tooltip();
                        $('[data-toggle="popover"]').popover();                      
                    });                 

                    self.isLoading = false;                   
                })
                .catch(error => {
                    this.isLoading = false;
                });
        },
        getIconClass: function (doc) {
            let icon = 'fas fa-file';
            switch(parseInt(doc.document_type_id)) {
                case DocumentType.INBOUND_FAX:
                case DocumentType.REMITTANCE:
                case DocumentType.CORRESPONDENCE:
                case DocumentType.LWC_FORM_1010_RESPONSE:
                case DocumentType.LWC_FORM_1009_RESPONSE:
                    icon = doc.read_at ? 'far fa-envelope-open' : 'far fa-envelope';
                    break;
                case DocumentType.CMS_1500:
                case DocumentType.CMS_1450:
                    icon = 'fas fa-file-invoice-dollar';
                    break;
                default:
                    break;
            }
            return icon + ' fa-lg';
        },
        getReadClass: function (doc) {            
            return (doc.document_type_id == DocumentType.INBOUND_FAX && !doc.read_at) ? 'font-weight-bold' : '';
        },
        getReadContent: function (doc) {
            return doc.read_by ? 'Read by ' +  doc.read_by.full_name + ' on ' +  this.$options.filters.localizeTime(doc.read_at, 'YYYY-MM-DD HH:mm:ss') : '';
        },
        changeDescription: function (document) {

            document.edit = false;

            // update the model
            this.$emit('update');

            // send the change to the server
            axios.patch('/ajax/documents/' + document.id + '/description', {
                'description': document.description,
            })
            .then(response => {
                // nothing to do
            })
            .catch(error => {
                // nothing to do
            });            
        },        
        showFaxSubmission: function () {

            let documentTypeId = this.getSelectedDocumentTypeId();
            if (documentTypeId) {
                eventHub.$emit('show-fax-submission', documentTypeId, this.selectedDocuments);
            }
        },
        showEmailSubmission: function () {

            let documentTypeId = this.getSelectedDocumentTypeId();
            if (documentTypeId) {
                eventHub.$emit('show-email-submission', documentTypeId, this.selectedDocuments);
            }             
        },
        getSelectedDocumentTypeId: function () {

            let retval = null;

            if (this.selectedDocuments.length > 0) {

                const documentTypeId = this.selectedDocuments[0].document_type.id;

                // if all documents are of the same type then return that document type id
                // otherwise it is a mixture of CMS 1500s and 1450s so return CMS_FORM document type id
                if (this.selectedDocuments.every(d => d.document_type.id === documentTypeId)) {
                    retval = documentTypeId;
                }
                else {
                    retval = DocumentType.CMS_FORM;
                }
            }
            
            return retval;
        },
        showSubmissionHistory: function (id) {
            eventHub.$emit('show-submission-history', id);
        },               
        uploadDocument: function (doc) {

            // default to uploading a 837 file
            let selectedOption = DocumentType.EDI_837;
            let options = this.options.map(x => {
                return {
                    id: x.id,
                    name: x.name
                };
            });

            // a document will be passed in if we are uploading an associated document
            if (doc) {

                // set the default selected document type and selection options
                selectedOption = DocumentType.REMITTANCE;
                options = this.options.find(x => x.id == doc.document_type_id).associated_document_types;
            }

            // show the upload file modal
            eventHub.$emit('show-file-upload', {
                claimId: this.claimId,
                url: '/ajax/claims/' + this.claimId + '/upload',
                options: options,
                documentType: selectedOption,
                associateToDocumentId: doc ? doc.id : null
            });                     
        },       
        confirmDisassociate: function (ancestorId, documentId) {
            const url = '/ajax/documents/' + documentId + '/disassociate';
            const message = 'Are you sure you want to unlink these documents?';
            eventHub.$emit('show-disassociate-confirmation', url, ancestorId, message);
        },          
        confirmDelete: function (id) {
            eventHub.$emit('show-delete-document-confirmation', id);
        },
        updateServiceDocument: function (data) {
            let document = this.documents.find(doc => doc.id == data.documentId);
            if (document) {
                document.estimatedReimbursement = data.reimbursement;
                document.balance = data.balance;
                document.document_status = data.documentStatus;
            }
        },
        confirmFinancing: function (id) {
            const title = "Send to Financing";
            const message = '<div>Are you sure you want to send the claim to financing?</div>';
            eventHub.$emit('show-confirmation', title, message, this.sendToFinancing, id);            
        },
        sendToFinancing: function (confirmed, id) {

            if (this.isAdmin && confirmed) {
                axios.get('/ajax/admin/documents/' + id + '/finance')
                    .then(response => { 
                        toastr[response.data.level](response.data.message, response.data.title, {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
                    })
                    .catch(error => { 
                        if (error.response.data) {
                            toastr[error.response.data.level](error.response.data.message, error.response.data.title, {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
                        }
                    });
            }
        },
        showFilters: function () {
            eventHub.$emit('show-service-filters', this.filters, this.filter);
        },
        filter: function (filters) {
            this.filters = filters;
        },
        getLocalDate: function (value) {

            let retval = null;

            if (value) {
                let date = new Date(value);
                retval = new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000)).toISOString().split('T')[0];
            }

            return retval;
        },
        markRead: function (document) {
            
            if (document) {

                // we need to update every place the document appears as an associated document
                this.documents.forEach(d => {
                    let associatedDoc = d.associated_documents.find(e => e.id == document.id);
                    if (associatedDoc) {
                        associatedDoc.read_at = document.read_at;
                        associatedDoc.read_by = document.read_by;
                    }                
                });
            }     
        },
        clearSelections: function () {
            this.documents.forEach(doc => {
                doc.selected = false;
            });
        },
        onChange: function (e, document) {
            document.selected = e.target.checked;           
        },
        uploadMailing: function (doc) {
            eventHub.$emit('show-mailing-upload', doc);
        },
        onDocumentNotes: function (document) {
            eventHub.$emit('show-document-notes', document.client_id, document.claim_id, document.id, document.document_type_id, false);
        },
        showPayerAuthorization: function(doc) {
            eventHub.$emit('show-link-authorization-modal', doc);
        }                                               
    },
    created() {
        this.refresh(true);
        eventHub.$on('update-claim-documents', this.refresh);
        eventHub.$on('update-document-read', this.markRead);
        eventHub.$on('update-service-document', this.updateServiceDocument); 
    },
    beforeDestroy() {
        eventHub.$off('update-claim-documents');
        eventHub.$off('update-document-read');
        eventHub.$off('update-service-document');
    },
    directives: {
        focus: {
            inserted: function (el) {
                el.focus();
            }
        }
    }         
}
</script>

<style scoped>
    .table-sm td {
        padding-top: 0;
        padding-bottom: 0;
        vertical-align: middle;
    }

    .table-stripe  {
        background-color:rgba(0,0,0,.05);
    }

    .edit-button {
        position: relative;
        top: -4px;
        opacity: 0;
    }

    .edit-button:hover {
        opacity: 1;
    }

    .btn-link {
        text-decoration: none;
    }
    
    .shrink {
        position: relative;
        top: -1px;
        font-size: .685em;
    }

    .stack-icon {
        position: relative;
        top: 2px;
        font-size: 1.0em;
    }

    .secure-email {
        position: relative;
        top: 4px;
        margin-right: 4px;
    }

    .lock {
        position: relative;
        top: 8px;
        left: 8px;
        color: #bcbcbc;
        font-size: 0.95em;
    }    
    
    .history-badge {
        font-size: 1em;
        position: relative;
        top: -12px;
        left: 10px;
    }     

    .instructions-icon {
        font-size: .60em;
        font-weight: bold;
        color: #6c757d;
    }

    .instructions {
        font-size: .90em;
        font-style: italic;
        font-weight: bold;
        color: #6c757d;
        position: relative;
        top: 2px;
    }
    
    /* overriding bootstrap unchecked background color; everything else remains the same */
    .custom-control-label::before {
        background-color: #ffffff;
        border: 1px solid #bbb;
          border-radius: 0.25rem;
    }

    .font-small {
        font-size: .95em;
    }      

    .font-small-italic {
        font-size: .60em;
        font-style: italic;
    }

    .icon-hidden {
       color: transparent; 
    }
    
    .fa-unlink {
        font-size: .90em;
    }

    .input-group {
        align-self: flex-start;
    }
    
    .fa-tags {
        font-size: 1.2em;
    }

    .attention {
        position: absolute;
        top: -0.4em;
        left: -.8rem;
        font-size: 75%;
        line-height: 0;
        vertical-align: baseline;        
    }
</style>